import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";

import {
    MDBTableHead,
    MDBTableBody,
    MDBBtn,
    MDBTable,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBModal,
    MDBTooltip,
    MDBInput,
    MDBCheckbox
} from "mdb-react-ui-kit";
import {Link, useNavigate} from "react-router-dom";
import {backendPathAuth, backendPathOfficeEmployees} from "../Constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faPen, faTrash} from "@fortawesome/free-solid-svg-icons";
import {InputGroup} from "react-bootstrap";
import {checkVisibility, switchVisibility} from "../functions/visibility";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";


function OfficeEmployees() {
    const navigate = useNavigate();

    const [officeEmployeesList, setOfficeEmployeesList] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [officeEmployeeId, setOfficeEmployeeId] = useState(0);
    const [customerNumber, setCustomerNumber] = useState(0);
    const [deletionPopupVisible, setDeletionPopupVisible] = useState(false);
    const [editFirstName, setEditFirstName] = useState(false);
    const [editLastName, setEditLastName] = useState(false);
    const [reload, setReload] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    const getOfficeEmployees = () => {
        Axios.get(backendPathOfficeEmployees+"office-employees-numbered.php").then((response) => {
            console.log(response.data);
            setOfficeEmployeesList(response.data);
        });
    };

    const toggleShow = () => setDeletionPopupVisible(!deletionPopupVisible);

    const deleteOfficeEmployee = () => {
        Axios.get(`${backendPathOfficeEmployees}delete-office-employee.php?id=${officeEmployeeId}`).then((response) => {
            setDeletionPopupVisible(false);
            getOfficeEmployees();
        });
    };

    const updateFirstName = (id, name) => {

        if (!firstName) {
            return;
        }

        Axios.get(backendPathOfficeEmployees+"update-office-employee-firstname.php", {
            params: {
                name: name,
                id: id,
            }
        }).then(() => {
            setEditFirstName(false);
            getOfficeEmployees();
        });

    };

    const updateLastName = (id, name) => {

        if (!lastName) {
            return;
        }

        Axios.get(backendPathOfficeEmployees+"update-office-employee-lastname.php", {
            params: {
                name: name,
                id: id,
            }
        }).then(() => {
            setEditLastName(false);
            getOfficeEmployees();
        });

    };

    useEffect(() => {
        getOfficeEmployees();
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    return (
        <>
        <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
        <div className="main">
            <div className="header-above-table d-flex align-items-center">
                <h2>Liste aller Mitarbeiter</h2>
                <Link className="link calendar-h" to="/new-office-employee">
                    <MDBBtn className="btn">hinzufügen</MDBBtn>
                </Link>
            </div>

            <MDBTable align='middle'>
                <MDBTableHead className="table-head">
                    <tr className="underlined-header">
                        <th scope='col'>Name</th>
                        <th scope='col'>Vorname</th>
                        <th scope='col'>aktive Kunden</th>
                        <th scope='col'>Sichtbar</th>
                        <th scope='col'></th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    <tr className="table-body"><td></td><td></td><td></td></tr>
                    {officeEmployeesList.map((val, key) => {
                        return (
                            <tr key={key}>
                                <td>{
                                    editLastName && officeEmployeeId === Number(val["OfficeEmployeeID"]) ?
                                        <InputGroup className="">
                                            <MDBInput className="" label='Name' type='text' value={lastName}
                                                      onChange={(event) => {
                                                          setLastName(event.target.value);
                                                      }}
                                            >
                                            </MDBInput>
                                            <MDBBtn onClick={(event) => {
                                                console.log(lastName);
                                                updateLastName(val["OfficeEmployeeID"], lastName);
                                            }}>
                                                <FontAwesomeIcon className='btn-icon' icon={faCheck}/>
                                            </MDBBtn>
                                        </InputGroup>

                                        :

                                        <div className="edit-partner-btn" onClick={() => {
                                            setOfficeEmployeeId(Number(val["OfficeEmployeeID"]));
                                            setLastName(val["LastName"]);
                                            setEditLastName(true);
                                        }}>
                                            {val["LastName"]}
                                            <FontAwesomeIcon className='btn-icon ms-3' icon={faPen}/>
                                        </div>
                                }
                                </td>
                                <td>{
                                    editFirstName && officeEmployeeId === Number(val["OfficeEmployeeID"]) ?
                                        <InputGroup className="">
                                            <MDBInput className="" label='Name' type='text' value={firstName}
                                                      onChange={(event) => {
                                                          setFirstName(event.target.value);
                                                      }}
                                            >
                                            </MDBInput>
                                            <MDBBtn onClick={(event) => {
                                                console.log(firstName);
                                                updateFirstName(val["OfficeEmployeeID"], firstName);
                                            }}>
                                                <FontAwesomeIcon className='btn-icon' icon={faCheck}/>
                                            </MDBBtn>
                                        </InputGroup>

                                        :

                                        <div className="edit-partner-btn" onClick={() => {
                                            setOfficeEmployeeId(Number(val["OfficeEmployeeID"]));
                                            setFirstName(val["FirstName"]);
                                            setEditFirstName(true);
                                        }}>
                                            {val["FirstName"]}
                                            <FontAwesomeIcon className='btn-icon ms-3' icon={faPen}/>
                                        </div>
                                }
                                </td>
                                <td>{val["CustomerNumber"] ? val["CustomerNumber"] : 0}</td>
                                <td>
                                    <MDBCheckbox name='flexCheck' value=''
                                                 checked={checkVisibility(val["OfficeEmployeeID"], "officeEmployee")}
                                                 onChange={
                                                     (event) => {
                                                         switchVisibility(val["OfficeEmployeeID"], "officeEmployee");
                                                         setReload(!reload);
                                                     }
                                                 }/>
                                </td>
                                <td>
                                    <MDBTooltip tag='a' wrapperProps={{}} title="löschen">
                                        <FontAwesomeIcon className='btn-icon trash-btn' icon={faTrash} onClick={
                                            () => {
                                                setOfficeEmployeeId(val["OfficeEmployeeID"]);
                                                setFirstName(val["FirstName"]);
                                                setLastName(val["LastName"]);
                                                setCustomerNumber(val["CustomerNumber"]);
                                                toggleShow()
                                            }}/>
                                    </MDBTooltip>

                                </td>
                            </tr>
                        );
                    })}
                </MDBTableBody>
            </MDBTable>

            <MDBModal show={deletionPopupVisible} setShow={setDeletionPopupVisible} tabIndex="-1">
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Mitarbeiter {firstName} {lastName} löschen</MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={toggleShow}
                            ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {customerNumber ?
                                "Wenn dieser Mitarbeiter gelöscht wird, wird auch bei " + customerNumber + "aktiven Kunden der eingetragene Mitarbeiter gelöscht." :
                                "Soll dieser Mitarbeiter wirklich gelöscht werden?"
                            }
                        </MDBModalBody>

                        <MDBModalFooter>
                            <MDBBtn className="btn-light" onClick={toggleShow}>
                                Abbrechen
                            </MDBBtn>
                            <MDBBtn onClick={deleteOfficeEmployee}>Löschen</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
        </>
    );
}

export default OfficeEmployees;